<div style="margin-top: 15px">
  <app-providers-coverage
    *ngIf="!!providerCoverage"
    [episodeTypes]="episodeTypes"
    [payers]="payers"
    [plans]="plans"
    [providerCoverage]="providerCoverage"
    [ianaTimeZone]="ianaTimeZone"
    (handleSuccess)="showSuccess()"
    (handleCancel)="cancel()"
  ></app-providers-coverage>

  <app-grid-wrapper #grid [hideLoadingMask]="true" suppressColumnAutoSizing="true">
    <button class="btn btn-primary" (click)="addEntity()"><i class="fa fa-plus"></i> Add</button>
  </app-grid-wrapper>
</div>
